import { userHasPermission, userHasRole } from "@accredo/fe-shared/utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    return userHasPermission(user, "insurer.all.read");
  },
  view: ({ user, insurer }) => {
    return userHasPermission(user, "insurer.all.read");
  },
  updateEmail: ({ user }) => {
    return userHasPermission(user, "insurer.all.write");
  },
};
